<template>
  <div class="logout-container d-flex align-items-center justify-content-center">
    <div class="text-center">
      <b-spinner label="Logging out..." variant="primary"></b-spinner>
      <p class="mt-3">Logging out...</p>
    </div>
  </div>
</template>

<script>
import { useAuth } from '@/composables/useAuth';

export default {
  name: 'PageLogout',
  
  async mounted() {
    const { logout } = useAuth();
    
    try {
      await logout();
    } catch (error) {
      console.error('Error during logout:', error);
    }
  }
};
</script>

<style scoped>
.logout-container {
  height: 100vh;
}
</style> 